//noScroll
class LoadingEvent {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {

    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null;
    }
    
    // クッキーの設定
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = `expires=${date.toUTCString()}`;
      document.cookie = `${name}=${value}; ${expires}; path=/`;
    }
    
    if (!getCookie("loading")) {
      setCookie("loading", "true", 1);
    
      gsap.to(".c-loading__content-top", { 
        x: "0%", 
        duration: 0.2, 
        delay: 0.4,
        onComplete: function() {
          document.querySelectorAll('.c-loading__content-top').forEach(function(content) {
            content.classList.add('is-active');
          });
        }
      });
    
      gsap.to(".c-loading__content-bottom", {
        x: "0%",
        duration: 0.2,
        delay: 0.4,
        onComplete: function() {
          document.querySelectorAll('.c-loading__content-bottom').forEach(function(content) {
            content.classList.add('is-active');
          });
        }
      });
    
      gsap.to(".c-loading__tire", { 
        duration: 0.3, 
        delay: 0.4 + 0.3,
        onComplete: function() {
          document.querySelectorAll('.c-loading__tire').forEach(function(tire) {
            tire.classList.add('is-active');
          });
        }
      });
    
      gsap.to(".c-loading__content-top", { 
        x: "-200%", 
        duration: 0.3, 
        delay: 2 
      });
    
      gsap.to(".c-loading__content-bottom", {
        x: "200%",
        duration: 0.3,
        delay: 2,
      });
    
      gsap.to(".c-loading__tire", { 
        duration: 0.3, 
        delay: 1.7, 
        onComplete: function() {
          document.querySelectorAll('.c-loading__tire').forEach(function(tire) {
            tire.classList.remove('is-active');
          });
        }
      });
    
      gsap.to(".c-loading", { 
        delay: 2, 
        onComplete: function() {
          document.querySelector('.c-loading').classList.add('is-hidden');
          // アニメーションが完了したことをローカルストレージに保存
          setCookie("loading", "true", 0.01);
          // .js-news-modalをフェードイン
          $('.js-news-modal').addClass('is-active');
        }
      });
      
    } else {
      document.querySelector('.c-loading').classList.add('is-hidden');
    }
    
  }
}
